import { computed } from 'vue';
import store from '@/store';
import i18n from '@/i18n';
export function useAudienceManager(isInclude, groupIndex) {
    const isViewMode = computed(() => store.getters['audienceManager/isView']);
    const isCreationMode = computed(() => !isViewMode.value);
    const groupType = computed(() => (isInclude ? 'include' : 'exclude'));
    const allCriteriaOptions = computed(() => store.getters['audienceManager/allCriteriaOptions']);
    const conditionsByGroupType = computed(() => {
        const EMPTY_INITIAL_GROUP = [];
        return store.getters['audienceManager/query'][groupType.value] ?? EMPTY_INITIAL_GROUP;
    });
    const stringOr = computed(() => `${i18n.global.t('or').toLowerCase()}`);
    const stringOrAnother = computed(() => `${i18n.global.t('or').toLowerCase()} ${i18n.global.t('another')}`);
    // Conditions
    const draftCondition = computed(() => {
        return (store.getters['audienceManager/editingCondition']?.[groupType.value]?.[groupIndex]?.draftCondition || {
            column: '',
            value: [],
            f_value: [],
            f_type: '',
        });
    });
    const selectedCriteriaDetails = computed(() => store.getters['audienceManager/selectedCriteriaDetails'](groupType.value, groupIndex));
    const keepFooterLoadingDuringInteraction = () => store.dispatch('audienceManager/triggerDebounceReset');
    const isBetweenOperator = computed(() => draftCondition.value?.operator === 'between' || draftCondition.value?.f_operator === 'between');
    const isFilterMode = computed(() => Boolean(selectedCriteriaDetails.value?.filter));
    return {
        isViewMode,
        isCreationMode,
        allCriteriaOptions,
        conditionsByGroupType,
        draftCondition,
        selectedCriteriaDetails,
        stringOr,
        groupType,
        stringOrAnother,
        isBetweenOperator,
        isFilterMode,
        keepFooterLoadingDuringInteraction,
    };
}
